module.exports = __webpack_public_path__ + "static/img/A78.2a529e00.jpg";